<template>
	<div :style="{width: '100%',height:(winHeight+37)+'px' ,background: '#eceef1',position: 'relative'}">
		<div v-if="!RegisterStatus" :style="{width: '100%',height: (winHeight+37)+'px','margin-top': '-37px'}">
			<Tabs v-model="Tabs"> 
				<TabPane name="1">
					<div style="height: 218px;width: 100%;text-align: center;font-size: 18px;background:#f8f8f9;">
						<Icon size="168" color="#458B74" type="ios-contact" /><br>
						用户注册
					</div>
					<div style="height: 305px;width: 100%;padding-top: 46px;padding-bottom:6px;background: #eceef1;">
						<Row type="flex" justify="center" align="center">
							<Col span="4">
							</Col>
							<Col span="16" style="font-size: 18px;padding-right: 6px;">
								<Input placeholder="11位手机号码" v-model="person.pphone" prefix="ios-phone-portrait" maxlength="11" :type="person.pphone.length==11?'text':'number'"/>
							</Col>
							<Col span="4">
							</Col>
						</Row>
						<Row type="flex" justify="center" align="center" style="height: 60px;padding-top: 16px;margin-bottom: 36px;">
							<Col span="4">
							</Col>
							<Col span="8">
								<Input ref="t1yzm" v-model="yzm" prefix="ios-lock-outline" maxlength="6" :type="yzm.length==6?'text':'number'"/>
							</Col>
							<Col span="12"  style="padding-top: 3px;padding-left: 8px;">
								<Button @click="sendSms" :disabled="person.pphone.length!=11||smsStatus" size="large" type="success" shape="circle">{{smsStatus?sms.djs+sms.msg:'获取验证码'}}</Button>
							</Col>
						</Row>
						<Row type="flex" justify="center" align="center" style="height: 20px;margin-top: 16px;">
							<Col span="3">
							</Col>
							<Col span="18" style="text-align: center;font-weight: 600; ">
								<Checkbox  v-model="agree">我同意</Checkbox><a  @click="userRegister=true" href="javascript:;">《用户注册协议》</a>
							</Col>
							<Col span="3" >
							</Col>
						</Row>
						<Row type="flex" justify="center" align="center">
							<Col span="3">
							</Col>
							<Col span="18">
								<Button @click="Register" :disabled="registerState" shape="circle" size="large" type="info" long>注册</Button>
							</Col>
							<Col span="3" >
							</Col>
						</Row>
						<!-- <Row type="flex" justify="center" align="center" style="height: 20px;margin-top: 16px;">
							<Col span="3">
							</Col>
							<Col span="18" style="text-align: center;font-weight: 600; ">
								注册代表你同意<a href="#">《用户注册协议》</a>
							</Col>
							<Col span="3" >
							</Col>
						</Row> -->
					</div>
				</TabPane>
				<TabPane name="2">
					<div style="height:218px;padding-top: 18px;width: 100%;text-align: center;font-size: 18px;background: #eceef1;">
						<img style="height: 136px;margin-bottom: 8px" src="../../../../assets/image/doctor.png" /></br>
						医务人员注册
					</div>
					<div style="height: 368px;width: 100%;padding-top: 12px;padding-bottom:6px;background:#f8f8f9;">
						<Row type="flex" justify="center" align="center" style="height: 80px;">
							<Col span="10">
							</Col>
							<Col span="4"> 
							<Upload
								ref="upload"
								name="idcardFile"
								accept="image/*"
								:format="['jpg','jpeg','png']"
								:on-format-error="handleFormatError"
								:on-exceeded-size="handleMaxSize"
								:max-size="6144"
								:on-success="uploadSuccess"
								:before-upload="prevUpload"
								:show-upload-list="false"
								:on-progress="uploadProgress"
								:on-error="uploadError"
								:action="uploadUrl">
								<div style="height: 80px;width: 60px;position: relative;margin: 0 auto;font-size: 12px;">
									<img style="height: 52px;width: 52px;margin: 0 auto;" src="../../../../assets/image/idcard_upload.png" />
									<div v-if="idcardSuccess" style="height: 26px;width: 26px; position: absolute;top: 26px;left: 2px;background:#f8f8f9 ;border-radius: 26px;">
										<Icon color="#19be6b" size="28" type="ios-checkmark-circle" />
									</div>
									<div v-if="idcardWarning" style="height: 26px;width: 26px; position: absolute;top: 26px;left: 2px;background:#f8f8f9 ;border-radius: 26px;">
										<Icon color="#ff9900" size="28" type="md-alert" />
									</div>
									{{idcardUploadMsg}}
								</div>
							</Upload>
								
							</Col>
							<Col span="10">
							</Col>
						</Row> 
						<Row type="flex" justify="center" align="center">
							<Col span="4">
							</Col>
							<Col span="16" style="font-size: 18px;padding-right: 6px;">
								<!-- <Input placeholder="15位科(股)室标识码" v-model="person.pdmark" prefix="md-infinite" maxlength="15" :type="person.pdmark.length==15?'text':'number'"/> -->
								<Input placeholder="15位科(股)室标识码" v-model="person.pdmark" maxlength="15" :type="person.pdmark.length==15?'text':'number'">
									<Icon type="md-infinite" slot="prefix"/>
								</Input>
							</Col>
							<Col span="4">
							</Col>
						</Row> 
						<Row type="flex" justify="center" align="center" style="height: 60px;padding-top: 16px;">
							<Col span="4">
							</Col>
							<Col span="16" style="font-size: 18px;padding-right: 6px;">
								<Input placeholder="11位手机号码" v-model="person.pphone" maxlength="11" :type="person.pphone.length==11?'text':'number'">
									<Icon type="ios-phone-portrait" slot="prefix"/>
								</Input>
							</Col>
							<Col span="4">
							</Col>
						</Row> 
						<Row type="flex" justify="center" align="center" style="height: 60px;padding-top: 16px;margin-bottom: 36px;">
							<Col span="4">
							</Col>
							<Col span="8">
								<Input ref="t2yzm" v-model="yzm" prefix="ios-lock-outline" maxlength="6" :type="yzm.length==6?'text':'number'">
									<Icon type="ios-lock-outline" slot="prefix"/>
								</Input>
							</Col>
							<Col span="12"  style="padding-top: 3px;padding-left: 8px;">
								<Button @click="sendSms" :disabled="person.pphone.length!=11||smsStatus" size="large" type="success" shape="circle">{{smsStatus?sms.djs+sms.msg:'获取验证码'}}</Button>
							</Col>
						</Row>
						<Row type="flex" justify="center" align="center" style="height: 20px;margin-top: 16px;">
							<Col span="3">
							</Col>
							<Col span="18" style="text-align: center;font-weight: 600; ">
								<Checkbox  v-model="agree">我同意</Checkbox><a @click="userRegister=true" href="javascript:;">《用户注册协议》</a>
							</Col>
							<Col span="3" >
							</Col>
						</Row>
						<Row type="flex" justify="center" align="center">
							<Col span="3">
							</Col>
							<Col span="18">
								<Button :disabled="registerState" @click="Register" shape="circle" size="large" type="info" long>注册</Button>
							</Col>
							<Col span="3" >
							</Col>
						</Row>
					</div>
				</TabPane>
			</Tabs>
		</div>
		<div v-if="!RegisterStatus" :style="{width: '100%',position: 'absolute',top: (winHeight+37-60-(winHeight>650?12:0))+'px'}">
			<Row type="flex" justify="center" align="center" style="height: 60px;">
				<Col span="8">
				</Col>
				<Col span="8" style="text-align: center;">
					<div style="width: 100%;">
						<Icon @click="doctorShow=!doctorShow,Tabs=doctorShow?'2':'1'" size="38" :type="doctorShow?'md-git-compare':'ios-git-compare'" /><br />
						{{doctorShow?'切换至用户版':'切换至医务人员版'}}
					</div>
				</Col>
				<Col span="8">
				</Col>
			</Row>
		</div>
		<div v-if="RegisterStatus" style="width: 100%;height: 100%;font-size: 23px;text-align: center;">
			<div style="height: 12rem;width: 100%;text-align: center;padding-top: 12px;font-size: 16px;">
				{{pageChangeMsg}}
			</div>
			<Icon type="md-checkmark-circle" size="140" color="#19BE6B"/><br/>
			注册成功
		</div>
		 <Drawer
            v-model="userRegister"
            :width="winWidth"
            :mask-closable="false"
			:placement="Tabs=='1'?'left':'right'"
			>
			<div style="height: 20px;line-height: 20px;width: 100%;text-align: center;font-size:20px ;" slot="header">用户注册协议</div>
			<div :style="{width: '100%',height:winHeight-20+'px'}" >
													<p class="MsoNormal" style="text-indent:26.25pt;">
					在此特别提醒您在注册成为健康珙县用户之前<span>,</span>请认真阅读本《用户注册协议》<span>(</span>以下简称“协议”<span>),</span>确保您充分理解本协议中各条款。请您审慎阅读并选择接受或不接受本协议。您同意并点击确认本协议条款且完成注册程序后<span>,</span>才能成为健康珙县的正式注册用户<span>,</span>并享受健康珙县的各类服务。您的注册、登录、使用等行为将视为对本协议的接受<span>,</span>并同意接受本协议各项条款的约束。若您不同意本协议<span>,</span>或对本协议中的条款存在任何疑问<span>,</span>请您立即停止健康珙县用户注册程序<span>,</span>并可以选择不使用健康珙县服务。本协议条款是健康珙县公司（以下称“健康珙县”或“我们”）对用户相关政策的许诺<span>,</span>请您务必仔细阅读。<span></span>
				</p>
				<p class="MsoNormal">
					<br />
				</p>
				<p class="MsoListParagraph" style="margin-left:18.0pt;text-indent:-18.0pt;">
					<b>一、</b><b>用户信息采集<span></span></b>
				</p>
				<p class="MsoListParagraph" style="text-indent:21.0pt;">
					当您在本网站<span>/</span>软件进行用户注册登记，使用本网站<span>/</span>软件的服务，以及参加本网站<span>/</span>软件的活动时，即为您同意本网站<span>/</span>软件将收集您的个人信息，并保存记录。本网站<span>/</span>软件收集的个人信息包括但不限于：姓名、性别、生日、城市、身份证号码、电子邮箱地址、手机电话、血型，收货地址等。您主动提供的信息越多及越准确，我们就能够更好地为您提供有关服务。 <span></span>
				</p>
				<p class="MsoListParagraph">
					<br />
				</p>
				<p class="MsoListParagraph" style="margin-left:18.0pt;text-indent:-18.0pt;">
					<b>二、</b><b>用户信息的使用<span></span></b>
				</p>
				<p class="MsoNormal" style="text-indent:21.0pt;">
					本网站<span>/</span>软件收集个人信息的基本目的是为了更好的了解我们的用户，以便向您提供特色服务和个性化服务。个人信息将主要用于以下几个目的： <span></span>
				</p>
				<p class="MsoListParagraph" style="margin-left:0cm;text-indent:20.0pt;">
					(1)完成您对特定服务或产品的要求。<span></span>
				</p>
				<p class="MsoListParagraph" style="margin-left:0cm;text-indent:20.0pt;">
					(2)在我们提供服务时<span>,</span>用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途<span>,</span>确保我们向您提供的产品和服务的安全性。 <span></span>
				</p>
				<p class="MsoListParagraph" style="margin-left:0cm;text-indent:20.0pt;">
					(3)帮助我们设计新服务<span>,</span>改善我们现有服务。<span></span>
				</p>
				<p class="MsoListParagraph" style="margin-left:0cm;text-indent:20.0pt;">
					(4)使我们更加了解您如何接入和使用我们的服务<span>,</span>从而针对性地回应您的个性化需求<span>,</span>例如语言设定、位置设定、个性化的帮助服务和指示<span>,</span>或对您和其他用户作出其他方面的回应。<span></span>
				</p>
				<p class="MsoListParagraph" style="margin-left:0cm;text-indent:20.0pt;">
					(5)用于对本网站<span>/</span>软件用户数据的统计（如用户数量、构成、兴趣、表现等），以便我们向用户提供更好的服务和产品，或向第三方为了一定的合法目的披露该类统计数据。该类统计数据都是用户群整体的信息，而非个人的信息。<span></span>
				</p>
				<p class="MsoListParagraph" style="margin-left:0cm;text-indent:20.0pt;">
					(6)让您参与有关我们产品和服务的调查。为了让您有更好的体验、改善我们的服务或您同意的其他用途<span>,</span>在符合相关法律法规的前提下<span>,</span>我们可能将通过某一项服务所收集的信息<span>,</span>以汇集信息或者个性化的方式<span>,</span>用于我们的其他服务。例如<span>,</span>在您使用我们的一项服务时所收集的信息<span>,</span>可能在另一服务中用于向您提供特定内容<span>,</span>或向您展示与您相关的、非普遍推送的信息。如果我们在相关服务中提供了相应选项<span>,</span>您也可以授权我们将该服务所提供和储存的信息用于我们的其他服务。<span></span>
				</p>
				<p class="MsoNormal" style="text-indent:15.75pt;">
					<br />
				</p>
				<p class="MsoListParagraph" style="margin-left:18.0pt;text-indent:-18.0pt;">
					<b>三、</b><b>用户信息的共享和披露<span></span></b>
				</p>
				<p class="MsoNormal" style="text-indent:21.0pt;">
					健康珙县信息所收集您的个人信息，将仅用于健康珙县为您提供相关服务。一般情况下，在未得到您的同意之前，您的任何个人信息将不会被提供给无关的第三方。
				在下列情况下，我们可能会将您的个人信息提供给有关的第三方： <span></span>
				</p>
				<p class="MsoListParagraph" style="margin-left:0cm;text-indent:20.0pt;">
					(1)本网站<span>/</span>软件的某些服务需由一个合作伙伴<span>(</span>如代理公司、提供相关技术服务的公司、运输公司、邮寄公司、提供奖品的公司等<span>)</span>提供或共同提供。为了向您提供此类服务，本网站有必要与该合作伙伴分享您的个人信息。如果您不希望您的信息被分享，您可以不使用该具体服务从而拒绝您的个人信息被披露。<span></span>
				</p>
				<p class="MsoListParagraph" style="margin-left:0cm;text-indent:20.0pt;">
					(2)本网站<span>/</span>软件可能会与第三方共同进行推广活动。在推广活动中所收集的全部或部分个人信息可能会与该第三方分享。如果您不想让您的信息被分享，您可以通过不参加该推广活动而拒绝。 <span></span>
				</p>
				<p class="MsoListParagraph" style="margin-left:0cm;text-indent:20.0pt;">
					(3)根据法律法规或政府的强制性规定，我们必须向有关司法或政府部门提供您的个人信息。<span></span>
				</p>
				<p class="MsoListParagraph" style="margin-left:0cm;text-indent:20.0pt;">
					(4)为了防止他人的合法权益或社会公共利益受到重大危害。<span></span>
				</p>
				<p class="MsoListParagraph" style="margin-left:0cm;text-indent:20.0pt;">
					(5)为了防止您的合法权益受到重大危害。 <span></span>
				</p>
				<p class="MsoListParagraph" style="margin-left:0cm;text-indent:20.0pt;">
					(6)我们发现您的行为违反了本网站<span>/</span>软件的服务条款或关于特定服务或产品的任何使用指引， 或对健康珙县信息的合法权益构成重大危害。<span></span>
				</p>
				<p class="MsoNormal" style="text-indent:21.0pt;">
					<br />
				</p>
				<p class="MsoListParagraph" style="margin-left:18.0pt;text-indent:-18.0pt;">
					<b>四、</b><b>用户管理<span></span></b>
				</p>
				<p class="MsoNormal" style="text-indent:26.25pt;">
					您可以在任何时候通过使用您的本网站<span>/</span>软件的注册用户名和密码，查询，补充或更正您的本网站<span>/</span>软件帐户中的个人信息，或要求删除您的本网站<span>/</span>软件帐户中的个人信息。您在本网站<span>/</span>软件的帐户可以被删除，但这样会导致您不能够登录本网站<span>/</span>软件及使用本网站<span>/</span>软件的任何服务。若发现任何非法使用用户帐号或存在安全漏洞的情况<span>,</span>请立即通知本站并向公安机关报案。因用户未妥善保管其帐号名称及密码而导致第三人使用帐号而给用户造成的损失<span>,</span>由用户自行承担
				</p>
				<p class="MsoNormal" style="text-indent:26.25pt;">
					用户在注册及使用时应承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线<span>,</span>且用户对其发布的内容<span>(</span>包括但不限于文字、图片等<span>)</span>时<span>,</span>不得有以下情形：
				</p>
				<p class="MsoListParagraph" style="margin-left:-1.7pt;text-indent:21.7pt;">
					(1)违反宪法或法律法规规定的<span>;</span>
				</p>
				<p class="MsoListParagraph" style="margin-left:-1.7pt;text-indent:21.7pt;">
					(2)危害国家安全<span>,</span>泄露国家秘密<span>,</span>颠覆国家政权<span>,</span>破坏国家统一的<span>;</span>
				</p>
				<p class="MsoListParagraph" style="margin-left:-1.7pt;text-indent:21.7pt;">
					(3)损害国家荣誉和利益的<span>,</span>损害公共利益的<span>;</span>
				</p>
				<p class="MsoListParagraph" style="margin-left:-1.7pt;text-indent:21.7pt;">
					(4)煽动民族仇恨、民族歧视<span>,</span>破坏民族团结的<span>;</span>
				</p>
				<p class="MsoListParagraph" style="margin-left:-1.7pt;text-indent:21.7pt;">
					(5)破坏国家宗教政策<span>,</span>宣扬邪教和封建迷信的<span>;</span>
				</p>
				<p class="MsoListParagraph" style="margin-left:-1.7pt;text-indent:21.7pt;">
					(6)散布谣言<span>,</span>扰乱社会秩序<span>,</span>破坏社会稳定的<span>;</span>
				</p>
				<p class="MsoListParagraph" style="margin-left:-1.7pt;text-indent:21.7pt;">
					(7)散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的<span></span>
				</p>
				<p class="MsoListParagraph" style="margin-left:-1.7pt;text-indent:21.7pt;">
					(8)侮辱或者诽谤他人<span>,</span>侵害他人合法权益的<span>;</span>
				</p>
				<p class="MsoListParagraph" style="margin-left:-1.7pt;text-indent:21.7pt;">
					(9)含有法律、行政法规禁止的其他内容或违反健康珙县的其他规定的。<span></span>
				</p>
				<p class="MsoListParagraph" style="margin-left:-1.7pt;text-indent:21.7pt;">
					(10)用户以虚假信息骗取帐号名称注册<span>,</span>或其帐号头像、简介等注册信息存在违法和不良信息的<span>,</span>健康珙县有权采取通知限期改正、暂停使用、注销登记等措施。健康珙县帐号仅限于用户本人使用<span>,</span>严禁将您的健康珙县帐号允许第三人使用<span>,</span>否则用户应承担由此产生的全部责任<span>,</span>并与实际使用人承担连带责任。<span></span>
				</p>
				<p class="MsoNormal" style="text-indent:21.0pt;">
					<br />
				</p>
				<p class="MsoListParagraph" style="margin-left:18.0pt;text-indent:-18.0pt;">
					<b>五、</b><b>信息安全<span></span></b>
				</p>
				<p class="MsoNormal" style="text-indent:21.0pt;">
					您的本网站<span>/</span>软件帐户信息和本网站<span>/</span>软件档案通过密码来保护，只有您个人才有权获取这些个人信息。我们建议您不要向任何他人泄露您的密码。本网站<span>/</span>软件也不会主动致电或主动发电子邮件给您来询问您的密码，如果您遇到此类情况请及时与健康珙县客服联系确认。同时，请您在完成工作后，务必退出您的本网站<span>/</span>软件帐户并关闭您的浏览器窗口，以便当您与他人合用一台电脑，或正在公共场所使用电脑时，保证他人无法获取您的个人信息和往来通信。遗憾的是，任何通过互联网或无线网络的数据传输都无法获得绝对的安全保证。所以，在我们尽最大努力来保护您的个人信息的同时，本网站<span>/</span>软件不能对您向我们进行的信息传输，或我们所发的在线产品或服务的信息的安全作出肯定或保证。您作出上述行为时将自己承担风险。一旦我们收到您传输来的信息，我们将尽最大努力保证其在我们系统的安全。<span></span>
				</p>
				<p class="MsoNormal">
					<br />
				</p>
				<p class="MsoListParagraph" style="margin-left:18.0pt;text-indent:-18.0pt;">
					<b>六、</b><b>用户隐私制度<span></span></b>
				</p>
				<p class="MsoNormal" style="text-indent:21.0pt;">
					我们会在您自愿的前提下收集您的个人信息并将这些信息进行整合<span>,</span>包括但不限于注册帐号时的相关信息和活动报名信息等。尊重用户个人隐私是健康珙县的一项基本政策。所以<span>,</span>健康珙县不会公开或向任何第三方透露用户的注册资料以及用户因享受健康珙县服务而提供的任何信息<span>,</span>但以下情形除外<span>:</span>
				</p>
				<p class="MsoListParagraph" style="margin-left:0cm;text-indent:20.0pt;">
					(1)事先获得用户的明确授权或许可<span>;</span>
				</p>
				<p class="MsoListParagraph" style="margin-left:0cm;text-indent:20.0pt;">
					(2)遵守有关法律规定<span>,</span>包括在国家有关机关查询时<span>,</span>提供用户的注册信息、用户在本站发布的信息内容及其发布时间、互联网地址或者域名等<span></span>
				</p>
				<p class="MsoListParagraph" style="margin-left:0cm;text-indent:20.0pt;">
					(3)在紧急情况下竭力维护用户个人和社会大众的隐私安全<span>;</span>
				</p>
				<p class="MsoListParagraph" style="margin-left:0cm;text-indent:20.0pt;">
					(4)根据本条款相关规定或者健康珙县认为必要的其他情形。健康珙县可能会与第三方合作向用户提供相关的网络服务<span>,</span>在此情况下<span>,</span>如该第三方同意承担与健康珙县同等的保护用户隐私的责任<span>,</span>则健康珙县可将用户信息提供给该第三方。<span></span>
				</p>
				<p class="MsoNormal">
					<br />
				</p>
				<p class="MsoListParagraph" style="margin-left:18.0pt;text-indent:-18.0pt;">
					<b>七、</b><b>所有权及知识产权条款<span></span></b>
				</p>
				<p class="MsoNormal" style="text-indent:21.0pt;">
					本<span>“</span>网站<span>/</span>软件<span>”</span>由健康珙县拥有和运作。本<span>“</span>网站<span>/</span>软件<span>”</span>公开或显示的所有内容，包括但不限于文字、图表、照片、图像、动画、音效、插图及软件（简称<span>“</span>内容<span>”</span>）等，均属健康珙县及其许可人或内容供应商所有。本<span>“</span>网站<span>/</span>软件<span>”</span>内的所有组成要素，包括但不限于整体设计及<span>“</span>内容<span>”</span>，均受商业外观、版权、道德规范、商标及其它所有相关知识产权的法律保护。除非依据本条款与条件或与经健康珙县在其它协议的声明同意外，本网站<span>/</span>软件內的任何部分或组成要素或<span>“</span>內容<span>”</span>均不得以任何方式复制或传播。除非有明确协议同意，否则网站<span>/</span>软件中的<span>“</span>內容<span>”</span>及一切相关权利将为健康珙县成员或其许可人的资产。<span></span>
				</p>
				<p class="MsoNormal" style="text-indent:21.0pt;">
					<br />
				</p>
				<p class="MsoListParagraph" style="margin-left:18.0pt;text-indent:-18.0pt;">
					<b>八、</b><b>责任限制<span></span></b>
				</p>
				<p class="MsoNormal" style="text-indent:21.0pt;">
					除非另有明确的书面说明<span>,</span>本站及其所包含的或以其它方式通过本站提供给您的全部信息、内容、材料、产品<span>(</span>包括软件<span>)</span>和服务<span>,</span>均是在<span>"</span>按现状<span>"</span>和<span>"</span>按现有<span>"</span>的基础上提供的。<span></span>
				</p>
				<p class="MsoNormal">
					除非另有明确的书面说明<span>,</span>我们不对本站的运营及其包含在本站上的信息、内容、材料、产品<span>(</span>包括软件<span>)</span>或服务作任何形式的、明示或默示的声明或担保<span>(</span>根据中华人民共和国法律<span></span>
				</p>
				<p class="MsoNormal">
					另有规定的以外<span>)</span>。我们不担保本站所包含的或以其它方式通过本站提供给您的全部信息、内容、材料、产品<span>(</span>包括软件<span>)</span>和服务、其服务器或从本站发出的电子信件、信息没有病毒或其他有害成分。如因不可抗力或其它本站无法控制的原因使本站服务系统溃或无法正常使用导致服务不可用或网上交易无法完成或丢失有关的信息、记录等<span>,</span>我们会合理地尽力协助处理善后事宜<span></span>
				</p>
				<p class="MsoNormal">
					<br />
				</p>
				<p class="MsoListParagraph" style="margin-left:18.0pt;text-indent:-18.0pt;">
					<b>九、</b><b>免责声明<span></span></b>
				</p>
				<p class="MsoNormal" style="text-indent:21.0pt;">
					客户明确同意使用健康珙县服务的风险由客户承担。健康珙县明确表示不提供任何类型的担保，不论是明确的或隐含的。健康珙县将尽力维护客户使用健康珙县服务的合法权益，但不担保健康珙县服务一定能满足客户的要求，也不担保服务的及时性、安全性、真实性、稳定性、正确性。对客户使用该等服务中出现的信息（包括但不限于客户发布的信息）删除或储存失败，健康珙县亦不承担任何责任。<span></span>
				</p>
				<p class="MsoNormal" style="text-indent:21.0pt;">
					客户理解并接受下载或通过相应产品服务取得的任何信息资料取决于客户自己，并自行承担系统受损、资料丢失以及其他任何风险。健康珙县对客户在互联网上得到的任何商品购物服务、交易进程、招聘信息等，都不作担保。<span></span>
				</p>
				<p class="MsoNormal" style="text-indent:21.0pt;">
					健康珙县对直接、间接、偶然、特殊及继起的损害不负责任，这些损害来自：不正当使用健康珙县服务及<span>/</span>或应用服务，在网上购买商品或类似服务，在网上进行交易，非法使用服务或客户传送的信息有所变动。<span></span>
				</p>
				<p class="MsoNormal" style="text-indent:21.0pt;">
					健康珙县对本项服务下涉及的境内外基础运营商的通信网络的故障、技术缺陷、覆盖范围限制、不可抗力、计算机病毒、黑客攻击、客户所在位置、客户关机或其他非健康珙县技术能力范围内的事因等造成的服务中断、客户邮件内容丢失、出现乱码、错误接收、无法接收、迟延接收不承担责任。<span></span>
				</p>
				<p class="MsoNormal" style="text-indent:21.0pt;">
					健康珙县保留判定客户的行为是否符合本服务协议要求的权利，如果客户违背了本服务协议的规定，健康珙县有权中止或终止相应健康珙县服务。<span>&nbsp; </span>
				</p>
				<p class="MsoNormal" style="text-indent:21.0pt;">
					转户规定：如果客户将手机号码转让给他人，请用户提前自行删除健康珙县内资料。否则，受让该号码的客户将能够查看您的客户个人数据。健康珙县不承担由此引发的客户数据丢失等责任及纠纷。
				</p>
				<p class="MsoNormal">
					<br />
				</p>
				<p class="MsoListParagraph" style="margin-left:18.0pt;text-indent:-18.0pt;">
					<b>十、</b><b>协议更新及用户关注义务<span></span></b>
				</p>
				<p class="MsoNormal" style="text-indent:21.0pt;">
					根据国家法律法规的更新及网站运营需要<span>,</span>我们有权对本条款不时地进行修改<span>,</span>修改后的服务条款一旦被张贴在本站上即生效力<span>,</span>并代替原来的服务条款。用户可随时登录查阅最新服务<span></span>
					条款内容。如用户不同意更新后的服务条款<span>,</span>应立即停止接受本站提供的服务<span>;</span>如用户继续使用本站提供的服务<span>,</span>即视为同意更新后的用户协议。我们建议您在使用本站之前阅读本用户<span></span>
					协议及本站的公告。如果本用户协议中任何一条被视为废止无效或因任何理由不可执行<span>,</span>该条应视为可分的且并不影响任何其余协议的有效性和可执行性。<span></span>
				</p>
				<p class="MsoNormal">
					<br />
				</p>
				<p class="MsoListParagraph" style="margin-left:18.0pt;text-indent:-18.0pt;">
					<b>十一、</b><b>法律管辖和适用<span></span></b>
				</p>
				<p class="MsoNormal" style="text-indent:21.0pt;">
					本用户协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区现行之有效法律。如发生本服务条款的某些内容与适用之法律相抵触时<span>,</span>则这些条款将完全按法律规定重新解释<span>,</span>而其它有效条款继续有效。如缔约方就本条款內容或其执行发生任何争议<span>,</span>双方应尽力友好协商解决<span>;</span>协商不成时<span>,</span>任何一方均可向咕咚所在地的中华人民共和国大陆地区法院提起诉讼。<span></span>
				</p>
				<p class="MsoNormal" style="text-indent:21.0pt;">
					<br />
				</p>
				<p class="MsoListParagraph" style="margin-left:18.0pt;text-indent:-18.0pt;">
					<b>十二、</b><b>其他<span></span></b>
				</p>
				<p class="MsoNormal" style="text-indent:21.0pt;">
					我们尊重用户的合法权利<span>,</span>本用户协议及本站上发布的各类规则、政策、声明等其他内容<span>,</span>均是为了更好的、更加便利的为用户提供服务。健康珙县欢迎用户和社会各界提出意见和建议<span>,</span>我们将虚心接受并适时修改本服务条款及相关政策、规则。<span></span>
				</p>
				<p class="MsoNormal" style="text-indent:21.0pt;">
					您完成注册且成为健康珙县的注册用户则意味着您完全接受本用户协议<span>,</span>在注册之前请您再次确认已知悉并完全理解本用户协议的全部内容。<span></span>
				</p>
			</div>
		</Drawer>
		
	</div>
</template>
<script>
	export default {
		data(){
			return {
				pageChangeMsg:'',
				returnPage:sessionStorage.returnPage?sessionStorage.returnPage:'/WeChat/Person',
				RegisterStatus:false,
				userRegister:false,
				doctorShow:false,
				idcardSuccess:false,
				idcardWarning:false,
				idcardUploadMsg:'上传身份证',
				smsStatus:false,
				yzm:'',
				smsYzm:'',
				sms:{
					djs:120,
					msg:'秒后重新获取'
				},
				winHeight:window.innerHeight,
				winWidth:window.innerWidth,
				uploadUrl:localStorage.ServerUrl+'/person/idcardUpload',
				person:{
					pdmark:'',
					pphone:'',
					pbirthday:'19000101',
					psex:'0',
					pnation:'汉'
				},
				phoneNumber:'',
				Tabs:'1',
				agree:true
			}
		},
		methods:{
			sendSms(){
				this.phoneNumber=this.person.pphone;
				this.$http.post('Sms/sendYzm?phoneNumber='+this.phoneNumber,'')
				.then((res)=> {
					if(res.code=='200'){
						this.smsStatus=true;
						this.smsYzm=res.data;
						let clock=window.setInterval(()=>{
							if(this.sms.djs==0){
								window.clearInterval(clock);
								this.sms.djs=60;
								this.smsStatus=false;
								return;
							}
							--this.sms.djs;
						},1000);
						this.Tabs=='1'?this.$refs.t1yzm.focus():this.$refs.t2yzm.focus();
						return;
					}
					this.$Message.error(res.msg);
				});
			},
			Register(){
				if(this.phoneNumber!=this.person.pphone){
					this.$Notice.warning({
						title: '手机号码错误',
						desc: '该手机号码未经验证，请重新进行验证'
					});
					return;
				}else if(this.smsYzm!=this.yzm){
					this.$Notice.warning({
						title: '验证码错误',
						desc: '请核对手机收到的验证码后再重试'
					});
					return;
				}
				this.$Spin.show({
					render: (h) => {
						return h('div', [
							h('Icon', {
								'class': 'demo-spin-icon-load',
								props: {
									type: 'ios-loading',
									size: 18
								}
							}),
							h('div', '注册中...')
						])
					}
				});
				this.$http.post('person/Register',this.person)
				.then((res)=> {
					if(res.code=='200'){
						this.person=res.data;
						let clock=window.setInterval(()=>{
							this.$Spin.hide();
							this.RegisterStatus=true;
							window.clearInterval(clock);
						},1500);
						return;
					}
					this.$Spin.hide();
					this.$Message.error(res.msg);
				});
			},
			uploadProgress(){
				this.idcardSuccess=false;
				this.idcardWarning=false;
				this.idcardUploadMsg='正在识别...';
			},
			uploadError(){
				this.idcardUploadMsg='上传出错';
				this.idcardWarning=true;
				this.$Notice.warning({
					title: '服务器错误',
					desc: '请联系管理员进行处理,联系QQ9305520'
				});
			},
			uploadSuccess(res, file) {
				if(res.code!='200'){
					this.Message.error(res.msg);
					return;
				}else if(res.data.Msg!=undefined){
					this.idcardUploadMsg='未能识别';
					this.idcardWarning=true;
					this.$Notice.warning({
						title: '识别错误',
						desc: res.data.Msg
					});
					return;
				}
				this.person.pname=res.data.person.pname;
				this.person.pnation=res.data.person.pnation;
				this.person.paddress=res.data.person.paddress;
				this.person.pno=res.data.person.pno;
				this.person.pbirthday=res.data.person.pbirthday;
				this.person.psex=res.data.person.psex=='男'?'0':'1';
				this.idcardUploadMsg='上传成功';
				this.idcardSuccess=true;
			},
			prevUpload(){
				this.$refs.upload.clearFiles();
				return true;
			},
			handleMaxSize(){
				this.$Notice.warning({
					title: '寸照大小错误',
					desc: '请上传1寸的寸照，且大小不能超过200k。'
				});
			},
			handleFormatError(){
				 this.$Notice.warning({
                    title: '寸照格式错误',
                    desc: '请选择正确的寸照格式上传，例如.png、.jpg、jpeg格式。'
                });
			}
		},
		computed: {
			registerState() {
				return this.agree!=true||this.yzm.length!=6||this.person.pphone.length!=11||(this.Tabs=='2'&&(this.person.pdmark.length!=15||this.idcardSuccess==false));
			}
		},
		watch:{
			RegisterStatus:{
				handler:function(curVal){
					if(curVal){
						let n=3;
						let clock=window.setInterval(()=>{
							if(n==0){
								window.clearInterval(clock);
								this.$router.push(this.returnPage);
							}
							this.pageChangeMsg=n+'秒后将跳转页面...';
							n--;
						},1000);
						
					}
				}
			}
		}
	}
</script>
<style>
	.ivu-input-wrapper{
		display: inline-block;
		width: 100%;
		position: relative;
		vertical-align: middle;
		line-height: 42px;
	}
	
	.ivu-input-wrapper input{
		height: 42px;
		line-height: 49px;
		font-size: 22px;
		border-radius: 21px;
	}
	
	.ivu-input-with-prefix{
		padding-left: 38px;
	}
	
	.ivu-input-prefix{
		width: 32px;
		height: 100%;
		text-align: center;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 1;
		padding-left: 8px;
	}
	
	.ivu-input-prefix i{
		font-size: 32px;
		line-height: 32px;
		color: #808695;
	}
</style>


// WEBPACK FOOTER //
// src/components/views/WeChat/Register/index.vue